import { render } from "./StripeConnectSuccess.vue?vue&type=template&id=50af0642"
import script from "./StripeConnectSuccess.vue?vue&type=script&lang=js"
export * from "./StripeConnectSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__